import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b420a98e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b420a98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b420a98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b420a98e')) {
      api.createRecord('b420a98e', component.options)
    } else {
      api.reload('b420a98e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=b420a98e&scoped=true&", function () {
      api.rerender('b420a98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Third-service-fee/detail.vue"
export default component.exports